// extracted by mini-css-extract-plugin
export default {"starsImage":"starsImage___W0IwZ","leftStars":"leftStars___e8vDi","rightStars":"rightStars___oTnzp"};